module.exports = {"220403001":"太安街道","220403002":"仙城街道","220403003":"东山街道","220403004":"先锋街道","220403005":"富国街道","220403006":"安家街道","220403100":"灯塔镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220403.json
// module id = 725
// module chunks = 0